import { useContext } from 'react';
import { ArticleContext } from '../contexts';
import { IArticle } from '../types';

export default function useArticle(): IArticle | undefined {
  const article = useContext(ArticleContext);
  return article;
}
